export default "__VITE_ASSET__Dn6OHQp1__"